import { DeviceHistoryFieldName } from './services/history-api.types';

export const historyLogTableSortField: Record<string, DeviceHistoryFieldName> = {
  dateLastAddedUTC: DeviceHistoryFieldName.DateLastAddedUTC,
  dateTimeUtcSet: DeviceHistoryFieldName.DateTimeUtcSet,
  deviceUID: DeviceHistoryFieldName.DeviceUID,
  updatedBy: DeviceHistoryFieldName.UpdatedBy,
  updateTypeName: DeviceHistoryFieldName.UpdateType,
  deviceTypeName: DeviceHistoryFieldName.DeviceType,
  modelName: DeviceHistoryFieldName.ModelName,
  meterNumber: DeviceHistoryFieldName.MeterNumber
};
